var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("How we start")]),_c('h3',[_vm._v("23 Ianuarie, 2021")]),_c('p',[_vm._v("Coming soon...")])])}]

export { render, staticRenderFns }